import { ConsentWidget, useConsentDraft, useTranslations } from 'c15t/react';
import { Text, Switch } from '@belong/ui';
import { IconCaretDown } from '@belong/icons';
import { useState } from 'react';
import { clsx } from 'clsx';

export function ConsentCategoriesList() {
  const [openCategory, setOpenCategory] = useState('');
  const translations = useTranslations();
  const { displayedCategories, values, set } = useConsentDraft();

  return (
    <div className="flex flex-col gap-xs">
      {displayedCategories.map((name) => {
        const isOpen = openCategory === name;

        return (
          <ConsentWidget.AccordionItem
            key={name}
            className="font-sans p-xs flex flex-col gap-xs cursor-pointer lg:hover:bg-light-gray lg:transition-colors lg:duration-hover"
            open={isOpen}
            onOpenChange={(next) => setOpenCategory(next ? name : '')}
          >
            <ConsentWidget.AccordionTrigger className="p-0 hover:bg-transparent">
              <ConsentWidget.AccordionTriggerInner className="flex h-full items-center gap-[6px] cursor-pointer text-navy">
                <ConsentWidget.AccordionArrow>
                  <IconCaretDown
                    className={clsx(
                      'h-[6px] w-auto transition-transform duration-[100ms] text-navy',
                      {
                        'rotate-180': isOpen,
                      },
                    )}
                  />
                </ConsentWidget.AccordionArrow>
                <Text as="span" fontWeight="semibold">
                  {translations.consentTypes[name]?.title ?? name}
                </Text>
              </ConsentWidget.AccordionTriggerInner>
              <Switch
                id={`consent-switch-${name}`}
                checked={values[name]}
                onChange={(next) => set(name, next)}
                disabled={name === 'necessary'}
              />
            </ConsentWidget.AccordionTrigger>
            <ConsentWidget.AccordionContent className="text-navy transition-none data-[state=closed]:hidden">
              <Text className="motion-safe:animate-consentAccordionIn">
                {translations.consentTypes[name]?.description}
              </Text>
            </ConsentWidget.AccordionContent>
          </ConsentWidget.AccordionItem>
        );
      })}
    </div>
  );
}
